import * as React from "react";

import classnames from "classnames";
import { IconContext } from "@dropbox/dig-icons";
import styles from "./LargeAccessory.module.css";

import type { IconAccessoryProps } from "@dropbox/dig-components/chip";

export const LargeIconAccessory = ({
  children,
  className,
}: IconAccessoryProps) => {
  return (
    <IconContext.Provider
      value={{
        UIIconOverrides: {
          size: "medium",
          isOpticallyAligned: true,
        },
      }}
    >
      <div className={classnames(styles.largeAccessory, className)}>
        {children}
      </div>
    </IconContext.Provider>
  );
};

// TODO: Add a LargeAvatarAccessory component
